var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ShadowlessElement } from '@blocksuite/lit';
import { baseTheme } from '@toeverything/theme';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { Point } from '../../../../_common/utils/index.js';
let DragPreview = class DragPreview extends ShadowlessElement {
    constructor(offset) {
        super();
        this.offset = offset ?? new Point(0, 0);
    }
    render() {
        return html `<style>
      affine-drag-preview {
        box-sizing: border-box;
        position: absolute;
        display: block;
        height: auto;
        font-family: ${baseTheme.fontSansFamily};
        font-size: var(--affine-font-base);
        line-height: var(--affine-line-height);
        color: var(--affine-text-primary-color);
        font-weight: 400;
        top: 0;
        left: 0;
        transform-origin: 0 0;
        opacity: 0.5;
        user-select: none;
        pointer-events: none;
        caret-color: transparent;
        z-index: 3;
      }

      .affine-drag-preview-grabbing * {
        cursor: grabbing !important;
      }
    </style>`;
    }
};
DragPreview = __decorate([
    customElement('affine-drag-preview')
], DragPreview);
export { DragPreview };
//# sourceMappingURL=drag-preview.js.map